





























































import { CommentType } from "@/enums";
import storeHelper from "@/store/store-helper";
import Utils from "@/utils";
import Vue from "vue";

export default Vue.extend({
    name: "CommentIcon",
    props: {
        type: String as () => CommentType,
        name: String,
        positionLeft: Boolean,
        positionRight: Boolean,
        createdDate: Object as () => Date
    },
    data: () => ({ commentType: { ...CommentType } }),
    methods: {},
    computed: {
        isIE(): boolean {
            return Utils.isIE11;
        },
        formattedCreatedDate(): string {
            return (
                Utils.formatDate(this.createdDate, storeHelper.userStore.loggedOnUser?.date_format) +
                ", " +
                Utils.padNumbers(this.createdDate.getHours(), 2) +
                ":" +
                Utils.padNumbers(this.createdDate.getMinutes(), 2)
            );
        },
        creatorName(): string {
            if (!this.name) {
                return this.$user.name;
            }
            return this.name;
        },
        initials() {
            let initials = "";

            if (!this.creatorName) return "";

            this.creatorName?.split(" ").forEach(x => {
                if (x != "") initials += x.charAt(0);
            });
            return initials.substring(0, 2).toUpperCase();
        }
    }
});
